import { Select } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { JoinOperator, getJoinOperatorList } from './filters.types';

type Inputs = {
  operator: JoinOperator;
  onChange: (operator: JoinOperator) => void;
  showWhere: boolean;
};
export const JoinOperators: FC<Inputs> = ({ operator, showWhere, onChange }) => {
  const { t } = useTranslation();
  const handleClick = () => {
    const newOperator: JoinOperator = operator === '&&' ? '||' : '&&';
    onChange(newOperator);
  };

  return (
    <div className="w-[80px] mr-1">
      {showWhere ? (
        <div className="text-center">{t('filters-where')}</div>
      ) : (
        <Select
          className="w-full"
          style={{ width: '80px' }}
          value={operator}
          onChange={onChange}
          options={getJoinOperatorList(t)}
          onClick={handleClick}
          open={false}
        />
      )}
    </div>
  );
};
